import * as React from "react";
import { useEffect, useCallback, useState, useMemo, useRef } from "react";
import "../../../styles/general.css";
import "./EpisodeListViewStyles.css";
import { EpisodeListItemView } from "./EpisodeListItemView";
import { useTranslation } from "react-i18next";
import { onEpisodePress, useFocusable } from "../../../utils/Helpers";
import { useRouter } from "../../../context/Router";
import { focusManager } from "../../../utils/Focus";
export var EpisodeListView = function (_a) {
    var episodes = _a.episodes, lastWatchedSeason = _a.lastWatchedSeason, seasons = _a.seasons, onClose = _a.onClose, movieStatus = _a.movieStatus, slug = _a.slug, currentEpisodeId = _a.currentEpisodeId;
    var navigate = useRouter().navigate;
    var t = useTranslation().t;
    var scrollRef = useRef(null);
    var _b = useState(seasons ? seasons[0] : 1), currentSeason = _b[0], setCurrentSeason = _b[1];
    var episodeListCloseRef = useFocusable({
        group: "episodeListClose",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    useEffect(function () {
        var i = seasons.indexOf(currentSeason);
        if (i === -1)
            return;
        var t = setTimeout(function () {
            focusManager.manualFocus("episodeListSeasons", i);
        }, 0);
        return function () { return clearTimeout(t); };
    }, [currentSeason, seasons]);
    useEffect(function () {
        focusManager.manualFocus("episodeListClose", 0);
    }, []);
    var filteredEpisodes = useMemo(function () { return episodes.filter(function (e) { return e.seasonNumber === currentSeason; }); }, [episodes, currentSeason]);
    useEffect(function () {
        focusManager.updateGroupOrder();
        focusManager.registerGroup({ name: "episodeListClose", position: 20 });
        focusManager.registerGroup({ name: "episodeListSeasons", position: 25 });
        filteredEpisodes.forEach(function (e, i) {
            return focusManager.registerGroup({
                name: "season-" + e.seasonNumber + "-" + i,
                position: i + 30,
                itemHeight: 132,
                verticalContainer: scrollRef.current,
            });
        });
    }, [currentSeason, filteredEpisodes]);
    var currentSeasonEpisodesLength = filteredEpisodes.length;
    useEffect(function () {
        var current = currentEpisodeId
            ? episodes.find(function (e) { return e.id === currentEpisodeId; })
            : undefined;
        setCurrentSeason((current === null || current === void 0 ? void 0 : current.seasonNumber) || lastWatchedSeason || seasons[0] || 1);
    }, [currentEpisodeId, lastWatchedSeason, episodes, seasons]);
    var handleEpisodePress = useCallback(function (episode) {
        onEpisodePress(episode, slug, navigate);
        onClose();
    }, [slug, navigate, onClose]);
    var renderItem = useCallback(function (episode, index) { return (React.createElement("div", { key: index, className: "episode-list-item" },
        React.createElement(EpisodeListItemView, { focusRaw: ["season-" + episode.seasonNumber + "-" + index, 0], episode: episode, isComingSoon: movieStatus === "CS" || episode.status === "CS", onEpisodePress: handleEpisodePress, isCurrentEpisode: episode.id === currentEpisodeId, onClose: onClose }))); }, [movieStatus, handleEpisodePress, currentEpisodeId, onClose]);
    return (React.createElement("div", { id: "episodes-list", className: "episode-list-container" },
        React.createElement("div", { id: "episode-list-header", className: "episode-list-header" },
            React.createElement("div", { className: "close-btn-container" },
                React.createElement("div", { className: "close", ref: episodeListCloseRef, tabIndex: 0 }),
                React.createElement("p", { className: "current-season", key: currentSeason },
                    t("movie.season"),
                    " ",
                    currentSeason),
                React.createElement("p", { className: "current-season-episodes" },
                    currentSeasonEpisodesLength,
                    " ",
                    currentSeasonEpisodesLength > 1
                        ? t("movie.episodes")
                        : t("movie.episode"))),
            React.createElement("div", { id: "seasons", className: "seasons-container" },
                React.createElement("p", { className: "seasons" },
                    t("movie.seasons"),
                    ": "),
                seasons.map(function (season, i) { return (React.createElement(EpisodeListSeasonView, { focusRaw: ["episodeListSeasons", i], key: "season-" + season, handleSeasonChange: setCurrentSeason, season: season, currentSeason: currentSeason, onClose: onClose })); }))),
        React.createElement("div", { className: "episode-list-wrapper" },
            React.createElement("div", { ref: scrollRef, className: "episodes-list-scroll-content" }, filteredEpisodes.map(function (episode, index) { return (React.createElement("div", { key: "episode-wrapper-" + episode.id, "data-scroll-index-wrapper": true }, renderItem(episode, index))); })))));
};
var EpisodeListSeasonView = function (_a) {
    var currentSeason = _a.currentSeason, handleSeasonChange = _a.handleSeasonChange, season = _a.season, focusRaw = _a.focusRaw, onClose = _a.onClose;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return handleSeasonChange(season); },
        onKeyBack: onClose,
    });
    return (React.createElement("div", { ref: ref, className: "season " + (currentSeason === season ? "active" : ""), tabIndex: 0 }, season));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/episode-list/EpisodeListView.tsx
// module id = 195
// module chunks = 1